import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { merge, of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { GaSessionService } from './../../session/services/session.service';
import { AccountsDataService } from './../services/accounts.data.service';
import {
    accountReadAction, accountReadFailureAction, accountReadSuccessAction, AccountState,
    accountUpdateAction, accountUpdateFailureAction, accountUpdateSuccessAction, getAccountData
} from './account.store';

@Injectable()
export class AccountEffects {
    constructor(
        private accountsDs: AccountsDataService,
        private actions$: Actions,
        private sessionService: GaSessionService,
        private store: Store<AccountState>
    ) { }

    read$ = createEffect(() => merge(...[
        this.actions$.pipe(ofType(accountReadAction)),
        this.sessionService.sessionUser$.pipe(filter(su => !!su))
    ]).pipe(
        switchMap(() => this.accountsDs.getCurrentAccount().pipe(
            map(account => accountReadSuccessAction({ account })),
            catchError(error => of(accountReadFailureAction({ error })))
        ))
    ));

    update$ = createEffect(() => this.actions$.pipe(
        ofType(accountUpdateAction),
        withLatestFrom(this.store.select(getAccountData)),
        switchMap(([action, account]) => this.accountsDs.updateAccount(account.id, defaultsDeep(action.account, account)).pipe(
            map(acc => accountUpdateSuccessAction({ account: acc })),
            catchError(error => of(accountUpdateFailureAction({ error })))
        ))
    ));

}
